window.jQuery = window.$ = require('jquery')

require('bootstrap')
require('mdbootstrap')
require('../../../fontawesome-pro-5.2.0-web/js/all') // use either scss or js version, not both
require('../../../fontawesome-pro-5.2.0-web/js/v4-shims') //  use either scss or js version, not both
require('ekko-lightbox')
require('slick-carousel')
require('../../../../../node_modules/@bower_components/magnific-popup/dist/jquery.magnific-popup')

$(document).ready(function () {

  /**************************************************
   * loading screen
   **************************************************/
  // $('.loading-screen').fadeOut();
  // $(window).on('beforeunload', function() {
  //   $('.loading-screen').fadeIn();
  // })

  /**************************************************
   * footer button scrollup
   **************************************************/
  $(".btn-uno-footer").click(function () {
    $("html, body").animate({scrollTop: $("header").offset().top}, "1000");
    return false;
  });

  $('.dropdown-menu .dropdown-toggle').on('click', function () {

    var $el = $(this)
    var $parent = $el.offsetParent('.dropdown-menu')

    if (!$el.next().hasClass('show')) {
      $el.parents('.dropdown-menu').first().find('.show').removeClass('show')
    }
    $el.next('.dropdown-menu').toggleClass('show').parent('li').toggleClass('show')

    $el.parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function () {
      $('.dropdown-menu .show').removeClass('show')
    })

    if (!$parent.parent().hasClass('navbar-nav')) {
      $el.next().css({'top': $el[0].offsetTop, 'left': $parent.outerWidth()})
    }

    return false
  })

  if($('#general-insurance').length) {
    $('#general-insurance-placeholder').html(document.getElementById('general-insurance').innerHTML);
    $('#general-insurance').remove();
  }

  $('#slick-general-insurance').ready(function(){
    $('#slick-general-insurance').on('init', function() {
      $('#slick-general-insurance').css({
        'opacity': 1
      });
    }).slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 576,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000
          }
        }
      ]
    });
  });

  $('.slick-general-insurance-prev').on('click', function () {
    $('#slick-general-insurance').slick('slickNext')
  })

  $('.slick-general-insurance-next').on('click', function () {
    $('#slick-general-insurance').slick('slickPrev')
  })

  $('#slick-banner .slick-banner-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: true,
    appendDots: $('.slick-banner-dots')
  });

  $('.slick-banner-prev').on('click', function () {
    $('#slick-banner .slick-banner-slider').slick('slickNext')
  })

  $('.slick-banner-next').on('click', function () {
    $('#slick-banner .slick-banner-slider').slick('slickPrev')
  })

  $('#slick-inner-banner .slick-inner-banner-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: false
  });

  $('.slick-inner-banner-prev').on('click', function () {
    $('#slick-inner-banner .slick-inner-banner-slider').slick('slickNext')
  })

  $('.slick-inner-banner-next').on('click', function () {
    $('#slick-inner-banner .slick-inner-banner-slider').slick('slickPrev')
  })

  document.getElementsByTagName('header')[0].style.paddingTop = document.getElementsByClassName("navbar")[0].clientHeight + "px";
  window.onresize = onWindowResize;
  function onWindowResize() {
    document.getElementsByTagName('header')[0].style.paddingTop = document.getElementsByClassName("navbar")[0].clientHeight + "px";
  }

  $('#journey-form').on('submit', function (event) {
    event.preventDefault()
    var role = $('#journey-role').val()
    var object = $('#journey-object').val()
    var route = $('#journey-form').attr('action')
    var locale = $('#journey-form').data('locale')
    $.post(route, {
      role: role,
      object: object,
      locale: locale,
    }, function (data) {
      if(data.status == 1) {
        window.location.replace(data.url);
      }
      $('#journeyResult').find('.modal-body p').html(data.message)
      $('#journeyResult').modal('show')
    })
  })
})
window.captchaCallback = function(response) {
    $(".g-recaptcha").val(response);
};



// WEBPACK FOOTER //
// ./resources/assets/js/front/unocms-v4/main.js